import { memo, useMemo } from 'react'
import type { ReactNode } from 'react'
import { useIntl } from 'react-intl'

import OfferCardCarouselSection from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'
import { OFFER_TYPE_HOTEL } from 'constants/offer'
import {
  ONLY_IN_AUSTRALIA_CAMPAIGN_PATH,
  ONLY_IN_AUSTRALIA_HERO_CAMPAIGN_TAG,
} from 'home/constants/onlyInAustraliaHeroCampaign'
import { MAX_CAROUSEL_ITEM_COUNT } from './common/constants'

const FILTERS: App.OfferListFilters = {
  offerTypes: [OFFER_TYPE_HOTEL],
  campaigns: [ONLY_IN_AUSTRALIA_HERO_CAMPAIGN_TAG],
  frontPageVisibleOnly: true,
  limit: MAX_CAROUSEL_ITEM_COUNT,
}

function OnlyInAustraliaHeroCarousel() {
  const intl = useIntl()

  const title = useMemo(() => intl.formatMessage(
    {
      id: 'reC3Si5KTubHTHAsE2_6',
      defaultMessage: 'Only in <i>Australia</i>',
      description:
        'Heading for the homepage carousel showcasing offers tagged for the Only in Australia campaign hero placement; Australia is styled in italics.',
    },
    {
      i: (chunks: ReactNode) => <i key="italic">{chunks}</i>,
    },
  ), [intl])

  return (
    <OfferCardCarouselSection
      filters={FILTERS}
      title={title}
      allLink={ONLY_IN_AUSTRALIA_CAMPAIGN_PATH}
      hideWhenEmpty
      tileStyle="card-default"
      tileSize="medium"
      id="only-in-australia-hero-carousel"
      data-testid="only-in-australia-hero-carousel"
    />
  )
}

export default memo(OnlyInAustraliaHeroCarousel)
